import { render } from "./WheelView.vue?vue&type=template&id=d132a8fc"
import script from "./WheelView.vue?vue&type=script&lang=js"
export * from "./WheelView.vue?vue&type=script&lang=js"

import "./WheelView.vue?vue&type=style&index=0&id=d132a8fc&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__